import { useContext } from 'react';

import { UserPermissionsContext } from './UserPermissionsProvider';

export const useUserPermissions = () => {
  return useContext(UserPermissionsContext);
};
